"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _I18n = _interopRequireDefault(require("I18n"));

var _reactRedux = require("react-redux");

var _hubspot = _interopRequireDefault(require("hubspot.PortalIdParser"));

var _GoToWebinars = require("lead-flows-ui/actions/GoToWebinars");

var _GoToWebinars2 = require("lead-flows-ui/selectors/GoToWebinars");

var _UISelect = _interopRequireDefault(require("UIComponents/input/UISelect"));

var _UIFormLabel = _interopRequireDefault(require("UIComponents/form/UIFormLabel"));

var _UILoadingSpinner = _interopRequireDefault(require("UIComponents/loading/UILoadingSpinner"));

var _UITooltip = _interopRequireDefault(require("UIComponents/tooltip/UITooltip"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var GoToWebinarSelect =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(GoToWebinarSelect, _PureComponent);

  function GoToWebinarSelect() {
    (0, _classCallCheck2.default)(this, GoToWebinarSelect);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(GoToWebinarSelect).apply(this, arguments));
  }

  (0, _createClass2.default)(GoToWebinarSelect, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      var fetchWebinarsSettings = this.props.fetchWebinarsSettings;
      fetchWebinarsSettings();
    }
  }, {
    key: "getLangKey",
    value: function getLangKey(suffix) {
      return "leadFlowEditor.leadFlowOptionsEditor." + suffix;
    }
  }, {
    key: "getWeibnarName",
    value: function getWeibnarName(webinar) {
      if (webinar.times && webinar.times[0]) {
        var start = _I18n.default.moment.portalTz(webinar.times[0].startTime).format('LLL');

        return webinar.subject + " " + start;
      }

      return webinar.subject;
    }
  }, {
    key: "getWebinarSelectOptions",
    value: function getWebinarSelectOptions() {
      var _this = this;

      var webinars = this.props.webinars;
      return webinars.map(function (webinar) {
        return {
          value: webinar.webinarKey,
          text: _this.getWeibnarName(webinar)
        };
      });
    }
  }, {
    key: "hasRequiredFields",
    value: function hasRequiredFields() {
      var formFields = this.props.formFields;
      var fieldNames = formFields.map(function (f) {
        return f.name;
      });
      return fieldNames.indexOf('email') !== -1 && fieldNames.indexOf('firstname') !== -1 && fieldNames.indexOf('lastname') !== -1;
    }
  }, {
    key: "renderLoadingContent",
    value: function renderLoadingContent() {
      return _react.default.createElement(_UILoadingSpinner.default, {
        grow: true,
        minHeight: 100
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          goToWebinarSyncEnabled = _this$props.goToWebinarSyncEnabled,
          selectedWebinarId = _this$props.selectedWebinarId,
          onChange = _this$props.onChange;

      if (!goToWebinarSyncEnabled) {
        return null;
      }

      var disabled = !this.hasRequiredFields();

      var selector = _react.default.createElement("span", null, _react.default.createElement(_UIFormLabel.default, {
        htmlFor: "bar"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: this.getLangKey('goToWebinarTitle')
      })), _react.default.createElement(_UISelect.default, {
        placeholder: _react.default.createElement(_FormattedMessage.default, {
          message: this.getLangKey('goToWebinarSelectionDefault')
        }),
        options: this.getWebinarSelectOptions(),
        onChange: onChange,
        value: selectedWebinarId,
        clearable: true,
        disabled: disabled
      }));

      var selectorWithMessage = disabled ? _react.default.createElement(_UITooltip.default, {
        title: _react.default.createElement(_FormattedMessage.default, {
          message: this.getLangKey('goToWebinarTooltip')
        })
      }, selector) : selector;
      return _react.default.createElement("div", {
        className: "webinar-selector"
      }, selectorWithMessage, _react.default.createElement(_Small.default, {
        use: "help"
      }, _react.default.createElement(_FormattedHTMLMessage.default, {
        message: this.getLangKey('goToWebinarConfig'),
        options: {
          portal: "" + _hubspot.default.get()
        }
      }), ' ', _react.default.createElement(_UIIcon.default, {
        name: "externalLink"
      })));
    }
  }], [{
    key: "propTypes",
    get: function get() {
      return {
        selectedWebinarId: _react.PropTypes.string,
        onChange: _react.PropTypes.func.isRequired,
        goToWebinarSyncEnabled: _react.PropTypes.bool.isRequired,
        goToWebinarSettingsRequestState: _react.PropTypes.object.isRequired,
        webinarsRequestState: _react.PropTypes.object.isRequired,
        fetchWebinarsSettings: _react.PropTypes.func.isRequired,
        fetchWebinars: _react.PropTypes.func.isRequired,
        webinars: _react.PropTypes.array.isRequired,
        formFields: _react.default.PropTypes.array
      };
    }
  }]);
  return GoToWebinarSelect;
}(_react.PureComponent);

var mapStateToProps = function mapStateToProps(state) {
  return {
    goToWebinarSyncEnabled: (0, _GoToWebinars2.getWebinarsSyncEnabled)(state),
    goToWebinarSettingsRequestState: (0, _GoToWebinars2.getWebinarsSettingsRequestState)(state),
    webinars: (0, _GoToWebinars2.getWebinars)(state),
    webinarsRequestState: (0, _GoToWebinars2.getWebinarsRequestState)(state)
  };
};

var actionsToBind = {
  fetchWebinarsSettings: _GoToWebinars.fetchWebinarsSettings,
  fetchWebinars: _GoToWebinars.fetchWebinars
};

var _default = (0, _reactRedux.connect)(mapStateToProps, actionsToBind)(GoToWebinarSelect);

exports.default = _default;
module.exports = exports.default;